(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ber-fall-winter"] && !Shopify.designMode) return;
  try {
    
(async()=>{const root=document.getElementById('ber-fall-winter');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const byId=id=>root.querySelector('[id="'+id+'"]');
const strings=JSON.parse(root.querySelector('[data-fw-strings]').textContent);
const decoder=document.createElement('textarea');for(const k of Object.keys(strings)){decoder.innerHTML=strings[k];strings[k]=decoder.value;}
const status=root.querySelector('[data-fw-status]');
root.querySelectorAll('.horizontal-rail').forEach(r=>r.setAttribute('aria-busy','true'));
let products=[],currency='CAD';
async function page(n){const url=new URL(root.dataset.feed,location.origin);url.searchParams.set('page',n);const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(20000)});if(!response.ok)throw Error('Catalogue unavailable');const data=await response.json();if(!Array.isArray(data.products)||!Number.isInteger(data.pages))throw Error('Invalid catalogue');return data;}
function uniqueProducts(list){return [...new Map(list.filter(p=>p.tags.some(tag=>String(tag).toLowerCase().includes('fw'))).map(p=>[p.id,p])).values()];}
function showLoadError(){status.hidden=false;status.textContent=strings.failed;const retry=document.createElement('button');retry.type='button';retry.className='text-link';retry.textContent=strings.retry;retry.addEventListener('click',()=>location.reload());status.append(' ',retry);root.dataset.catalogueState='partial';}
let seed;
try{seed=JSON.parse(root.querySelector('[data-fw-seed]').textContent);if(!Array.isArray(seed.products)||!Number.isInteger(seed.pages))throw Error('Invalid seed');}catch(error){try{seed=await page(1);}catch(error){showLoadError();root.querySelectorAll('.horizontal-rail').forEach(r=>r.setAttribute('aria-busy','false'));return;}}
products=uniqueProducts(seed.products);currency=seed.currency||'CAD';
root.dataset.productCount=products.length;root.dataset.catalogueState='loading';status.hidden=products.length>0;
const pendingCatalogue=Promise.all(Array.from({length:seed.pages},(_,i)=>page(i+1))).then(batches=>({products:uniqueProducts(batches.flatMap(d=>d.products))}),error=>({error}));
root.querySelectorAll('.horizontal-rail').forEach(r=>r.setAttribute('aria-busy','false'));
const brandCollections={"BELLABU BEAR":"/collections/bellabu-bear","BIOMECANICS":"/collections/biomecanics","BOGS":"/collections/bogs","BOXBO":"/collections/boxbo","COCCOLI":"/collections/coccoli","COLOR KIDS":"/collections/color-kids","CONDOR":"/collections/condor","EMERSON AND FRIENDS":"/collections/emerson-and-friends","FLAPJACKKIDS":"/collections/flapjackkids","GARVALIN":"/collections/garvalin","HUTTELIHUT":"/collections/huttelihut","JAN & JUL":"/collections/jan-jul","KEEN":"/collections/keen","KIDORCA":"/collections/kidorca","KONGES SLOJD":"/collections/konges-slojd","KUOMA":"/collections/kuoma","LOULOU LOLLIPOP":"/collections/loulou-lollipop","MAYORAL":"/collections/mayoral","MINI A TURE":"/collections/mini-a-ture","NEST DESIGNS":"/collections/nest-designs","NEW BALANCE":"/collections/new-balance","PETITE REVERY":"/collections/petite-revery","ROSSIGNOL":"/collections/rossignol","SNOWSTOPPERS":"/collections/snowstoppers","STONZ":"/collections/stonz","THE NORTH FACE":"/collections/the-north-face","UGG":"/collections/ugg","UP BABY":"/collections/up-baby","VESSI":"/collections/vessi","WEEDO":"/collections/weedo","ZOOCCHINI":"/collections/zoocchini"};
let vendors=[];
function renderBrands(){
 vendors=[...new Set(products.map(p=>p.vendor))].sort((a,b)=>a.localeCompare(b));
 const group=root.querySelector('.brand-group');group.replaceChildren();
 for(const vendor of vendors){const li=document.createElement('li'),a=document.createElement('a'),span=document.createElement('span');a.href=brandCollections[vendor.toUpperCase()]||'/collections/vendors?q='+encodeURIComponent(vendor);a.dataset.brand=vendor;a.className='brand-item';span.className='brand-name';span.textContent=vendor;a.append(span);li.append(a);group.append(li);}
 root.dataset.brandCount=vendors.length;
}
renderBrands();
const isOnSale=p=>p.sale===true;const syncSaleEntries=(list,scope)=>scope.querySelectorAll('[data-sale-entry]').forEach(e=>e.hidden=!list.some(isOnSale));
syncSaleEntries(products,root);
const safe=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const priceFormatter=new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency});
const money=n=>priceFormatter.format(n);
function card(p,saleView=false){
 const sale=isOnSale(p);saleView=saleView&&sale;
 const price=saleView?p.sale_price:p.price,compare=saleView?p.sale_compare:p.compare_at_price;

 const url=p.url+(saleView?'?variant='+p.sale_variant:'');
 return '<article class="product-card"><a class="product-card-link" href="'+safe(url)+'"><span class="product-image">'+(p.image?'<img src="'+safe(p.image)+'" width="500" height="500" loading="lazy" alt="">':'')+'</span><h3 class="product-title">'+safe(p.title)+'</h3><p class="product-price'+(sale?' is-sale':'')+'">'+(sale?'<span class="sale-label">'+safe(saleView||compare>price?strings.sale:strings.selected_sale)+'</span> ':'')+(p.price_varies?safe(strings.from)+' ':'')+safe(money(price))+(compare>price&&p.available?'<del class="compare-price">'+safe(money(compare))+'</del>':'')+'</p>'+(!p.available?'<p class="stock-note">'+safe(strings.sold_out)+'</p>':'')+'</a></article>';
}
const compactProducts=matchMedia('(max-width: 1020px)');
const pageData=new WeakMap();
function hydratePage(element){const data=pageData.get(element);if(!data||element.dataset.hydrated==='true')return;element.innerHTML=data.list.map(p=>card(p,data.saleView)).join('');element.dataset.hydrated='true';}
const railObservers=new Map();
function renderRail(rail,list,saleView=false,reset=true){
 let observer=railObservers.get(rail);
 if(!observer){observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)hydratePage(entry.target)}),{root:rail,rootMargin:'0px 100% 0px 100%'});railObservers.set(rail,observer);}
 if(reset){observer.disconnect();rail.replaceChildren();rail.scrollTo({left:0,behavior:'auto'});}
 const size=compactProducts.matches?4:6;
 for(let i=0;i<list.length;i+=size){
  const slice=list.slice(i,i+size),index=i/size,key=slice.map(p=>p.id).join(',');let element=rail.children[index];
  if(!element){element=document.createElement('div');element.className='product-page';element.setAttribute('role','group');rail.append(element);observer.observe(element);}
  element.setAttribute('aria-label','Products '+(i+1)+' to '+Math.min(i+size,list.length));
  if(element.dataset.productIds!==key){const visible=element.dataset.hydrated==='true';element.dataset.productIds=key;element.dataset.hydrated='false';pageData.set(element,{list:slice,saleView});if(index===0||visible)hydratePage(element);}
 }
 rail.dataset.productCount=list.length;updateRail(rail);
}
function shuffleProducts(list){
 const shuffled=list.slice();
 for(let i=shuffled.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[shuffled[i],shuffled[j]]=[shuffled[j],shuffled[i]];}
 return shuffled;
}
const featuredPool=shuffleProducts(products.filter(p=>p.available));
const selected=shuffleProducts(vendors.map(vendor=>featuredPool.find(p=>p.vendor===vendor)).filter(Boolean));
const groups={cozy:shuffleProducts(products.filter(p=>p.tags.includes('SNOWGEAR'))),rain:shuffleProducts(products.filter(p=>p.tags.includes('RAINGEAR'))),sale:shuffleProducts(products.filter(isOnSale))};
function renderSections(reset=true){
 renderRail(byId('featured-products'),selected,false,reset);
 for(const [name,list] of Object.entries(groups)){renderRail(byId(name+'-products'),list,name==='sale',reset);byId(name+'-edit').dataset.productCount=list.length;byId(name+'-edit').hidden=!list.length;}
}
renderSections();root.dataset.firstRenderMs=Math.round(performance.now());compactProducts.addEventListener('change',()=>renderSections(true));

function updateRail(rail){
 const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
 root.querySelectorAll('[data-rail="'+rail.id+'"]').forEach(button=>{
  button.disabled=Number(button.dataset.step)<0?rail.scrollLeft<=2:rail.scrollLeft>=max-2;
 });
 rail.nextElementSibling.hidden=!rail.children.length;
 const page=Math.min(rail.children.length,Math.round(rail.scrollLeft/Math.max(1,rail.clientWidth))+1);
 const hint=rail.nextElementSibling.querySelector('.rail-hint');
 const count=Number(rail.dataset.productCount)||0;
 hint.textContent=rail.children.length>1?strings.page+' '+page+' / '+rail.children.length:count+' '+strings.products;
}
function pageRail(rail,direction){
 const first=rail.firstElementChild;if(!first)return;
 const gap=parseFloat(getComputedStyle(rail).columnGap)||0;
 const stride=first.getBoundingClientRect().width+gap;
 const count=Math.max(1,Math.floor((rail.clientWidth+gap+2)/stride));
 rail.scrollBy({left:direction*count*stride,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
root.querySelectorAll('.horizontal-rail').forEach(rail=>{
 rail.addEventListener('scroll',()=>updateRail(rail),{passive:true});
 rail.addEventListener('keydown',event=>{
  if(event.target!==rail||!['ArrowLeft','ArrowRight'].includes(event.key))return;
  event.preventDefault();pageRail(rail,event.key==='ArrowLeft'?-1:1);
 });
 new ResizeObserver(()=>updateRail(rail)).observe(rail);
 updateRail(rail);
});
root.querySelectorAll('[data-rail]').forEach(button=>button.addEventListener('click',()=>{
 pageRail(byId(button.dataset.rail),Number(button.dataset.step));
}));


const marquee=byId('brand-rail');
const brandTrack=marquee.querySelector('.brand-track');

for(let copy=0;copy<3;copy++){
 const duplicate=brandTrack.firstElementChild.cloneNode(true);
 duplicate.setAttribute('aria-hidden','true');
 duplicate.querySelectorAll('a').forEach(link=>{
  link.tabIndex=-1;

 });
 brandTrack.append(duplicate);
}
const expandButton=byId('brand-expand');
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
let brandVisible=false,brandsExpanded=false;
function syncBrandMotion(){
 marquee.dataset.running=String(brandVisible&&!brandsExpanded&&!reducedMotion.matches&&!document.hidden);
}
expandButton.addEventListener('click',()=>{
 brandsExpanded=!brandsExpanded;marquee.classList.toggle('expanded',brandsExpanded);
 expandButton.setAttribute('aria-expanded',String(brandsExpanded));
 expandButton.innerHTML=brandsExpanded?safe(strings.fewer)+' <span aria-hidden="true">−</span>':safe(strings.more)+' <span aria-hidden="true">+</span>';
 syncBrandMotion();
});
new IntersectionObserver(entries=>{brandVisible=entries[0].isIntersecting;syncBrandMotion()},{threshold:.1}).observe(marquee);
document.addEventListener('visibilitychange',syncBrandMotion);
reducedMotion.addEventListener('change',syncBrandMotion);
syncBrandMotion();

pendingCatalogue.then(result=>{
 if(result.error){showLoadError();return;}
 products=result.products;renderBrands();
 brandTrack.querySelectorAll('[aria-hidden="true"]').forEach(node=>node.remove());
 for(let copy=0;copy<3;copy++){const duplicate=brandTrack.firstElementChild.cloneNode(true);duplicate.setAttribute('aria-hidden','true');duplicate.querySelectorAll('a').forEach(link=>link.tabIndex=-1);brandTrack.append(duplicate);}
 const represented=new Set(selected.map(p=>p.vendor));
 for(const p of shuffleProducts(products.filter(p=>p.available))){if(!represented.has(p.vendor)){selected.push(p);represented.add(p.vendor);}}
 for(const [name,predicate] of Object.entries({cozy:p=>p.tags.includes('SNOWGEAR'),rain:p=>p.tags.includes('RAINGEAR'),sale:isOnSale})){
  const existing=new Set(groups[name].map(p=>p.id));groups[name].push(...shuffleProducts(products.filter(p=>predicate(p)&&!existing.has(p.id))));
 }
 renderSections(false);syncSaleEntries(products,root);root.dataset.productCount=products.length;root.dataset.catalogueState='complete';root.dataset.completeMs=Math.round(performance.now());status.hidden=true;syncBrandMotion();
});

root.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{const target=root.querySelector(link.getAttribute('href'));if(!target)return;event.preventDefault();const header=document.querySelector('.page-header');const bottom=header?header.getBoundingClientRect().bottom:100;const offset=Math.max(110,Math.min(bottom+20,170));window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-offset,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}));})();
(()=>{
  const section=document.getElementById('featured-brands');
  if(!section||section.dataset.ready)return;
  section.dataset.ready='true';
  const rail=section.querySelector('.featured-brand-rail');
  const pairs=[...rail.children];
  const progress=section.querySelector('.featured-brand-progress');
  const strings=JSON.parse(section.querySelector('[data-featured-brand-strings]').textContent);
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let stride=1,maxScroll=1,position=0,index=0,timer,scrollTimer,visible=false,hovered=false,focused=false,userPaused=false,drag,suppressClick=false;
  function stop(){clearTimeout(timer);timer=undefined;}
  function allowed(){return pairs.length>1&&visible&&!document.hidden&&!reduced.matches&&!hovered&&!focused&&!userPaused;}
  function sync(){
    stop();
    section.dataset.autoplay=allowed()?'running':'paused';
    if(allowed())timer=setTimeout(()=>go((index+1)%pairs.length,false),5000);
  }
  function update(){
    index=Math.max(0,Math.min(pairs.length-1,Math.round(rail.scrollLeft/stride)));
    section.dataset.page=String(index+1);
    position=Math.max(0,Math.min(100,rail.scrollLeft/maxScroll*100));
    progress.value=String(Math.round(position*10)/10);
    progress.setAttribute('aria-valuetext',strings.progress.replace('PERCENT',progress.value));
  }
  function measure(){const gap=parseFloat(getComputedStyle(rail).columnGap)||0;const nextStride=rail.clientWidth+gap;const nextMax=Math.max(1,rail.scrollWidth-rail.clientWidth);if(stride!==nextStride||maxScroll!==nextMax){stride=nextStride;maxScroll=nextMax;rail.scrollTo({left:position/100*maxScroll,behavior:'auto'});}update();sync();}
  function go(page,manual,instant=false){stop();if(manual)userPaused=true;rail.scrollTo({left:page*stride,behavior:reduced.matches||instant?'auto':'smooth'});sync();}
  progress.addEventListener('input',()=>{userPaused=true;stop();rail.scrollTo({left:Number(progress.value)/100*maxScroll,behavior:'auto'});update();sync();});
  progress.addEventListener('pointerdown',()=>{userPaused=true;sync();},{passive:true});
  rail.addEventListener('pointerdown',event=>{userPaused=true;sync();if(event.pointerType==='mouse'&&event.button===0)drag={id:event.pointerId,x:event.clientX,left:rail.scrollLeft,moved:false};},{passive:true});
  rail.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId)return;const distance=event.clientX-drag.x;if(!drag.moved&&Math.abs(distance)>6){drag.moved=true;rail.classList.add('is-dragging');rail.setPointerCapture(event.pointerId);}if(drag.moved){event.preventDefault();rail.scrollLeft=drag.left-distance;}});
  function endDrag(){if(!drag)return;const moved=drag.moved;const pointerId=drag.id;drag=undefined;if(rail.hasPointerCapture(pointerId))rail.releasePointerCapture(pointerId);rail.classList.remove('is-dragging');if(moved){suppressClick=true;update();sync();setTimeout(()=>suppressClick=false,0);}}
  rail.addEventListener('pointerup',endDrag);rail.addEventListener('pointercancel',endDrag);rail.addEventListener('lostpointercapture',endDrag);
  rail.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();}},true);
  rail.addEventListener('dragstart',event=>event.preventDefault());
  rail.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown'].includes(event.key)){userPaused=true;sync();}});
  rail.addEventListener('scroll',()=>{update();clearTimeout(scrollTimer);scrollTimer=setTimeout(sync,140);},{passive:true});
  section.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;sync();}});
  section.addEventListener('pointerleave',()=>{hovered=false;sync();});
  section.addEventListener('focusin',()=>{focused=true;sync();});
  section.addEventListener('focusout',()=>{queueMicrotask(()=>{focused=section.contains(document.activeElement);sync();});});
  document.addEventListener('visibilitychange',sync);
  reduced.addEventListener('change',sync);
  new ResizeObserver(measure).observe(rail);
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.2}).observe(rail);
  pairs.forEach((pair,i)=>pair.setAttribute('aria-label',(i+1)+' / '+pairs.length));
  measure();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ber-stroller-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toEmbedUrl = (rawUrl) => {
      try {
        const url = new URL(rawUrl, window.location.origin);
        let id = '';
        if (url.hostname.includes('youtu.be')) id = url.pathname.split('/').filter(Boolean)[0] || '';
        if (url.hostname.includes('youtube.com')) {
          id = url.searchParams.get('v') || url.pathname.split('/embed/')[1] || url.pathname.split('/shorts/')[1] || '';
        }
        id = id.split(/[?&/]/)[0];
        return /^[A-Za-z0-9_-]{6,}$/.test(id)
          ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`
          : '';
      } catch (error) {
        return '';
      }
    };

    document.querySelectorAll('[data-ber-video-url]').forEach((button) => {
      if (button.dataset.berReady === 'true') return;
      button.dataset.berReady = 'true';
      button.addEventListener('click', () => {
        const src = toEmbedUrl(button.dataset.berVideoUrl || '');
        if (!src) return;
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = button.getAttribute('aria-label') || 'Brand video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        button.replaceWith(iframe);
      }, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event){
    if(window.location.href.includes('?brand-list=')){
      const url = new URL(window.location.href);
      const brandListValue = url.searchParams.get('brand-list');
      const anchor = document.querySelector(`[href="#brand-list-${brandListValue}"]`);
      if(anchor) anchor.dispatchEvent(new Event('click'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hub-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-contact]');
    if (!root) return;
    const button = root.querySelector('[data-ber-open-chat]');
    const hint = root.querySelector('[data-ber-chat-hint]');
    if (!button) return;
    const findNativeChatActivator = (rootNode) => {
      if (!rootNode) return null;
      const directControl = rootNode.querySelector?.('button[part="activator"], button.activator');
      if (directControl) return directControl;
      const descendants = rootNode.querySelectorAll?.('*') || [];
      for (const element of descendants) {
        if (!element.shadowRoot) continue;
        const nestedControl = findNativeChatActivator(element.shadowRoot);
        if (nestedControl) return nestedControl;
      }
      return null;
    };
    const openChat = () => {
      const host = document.querySelector('shopify-chat');
      if (typeof host?.show === 'function') {
        host.show();
        return true;
      }
      const control = findNativeChatActivator(host?.shadowRoot);
      if (!control) return false;
      control.click();
      return true;
    };
    button.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      if (openChat()) return;
      button.setAttribute('aria-busy', 'true');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const opened = openChat();
        if (opened || attempts >= 8) {
          window.clearInterval(timer);
          button.removeAttribute('aria-busy');
          if (!opened && hint) hint.hidden = false;
        }
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hub-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-contact]');
    if (!root) return;
    const button = root.querySelector('[data-ber-open-chat]');
    const hint = root.querySelector('[data-ber-chat-hint]');
    if (!button) return;
    const findNativeChatActivator = (rootNode) => {
      if (!rootNode) return null;
      const directControl = rootNode.querySelector?.('button[part="activator"], button.activator');
      if (directControl) return directControl;
      const descendants = rootNode.querySelectorAll?.('*') || [];
      for (const element of descendants) {
        if (!element.shadowRoot) continue;
        const nestedControl = findNativeChatActivator(element.shadowRoot);
        if (nestedControl) return nestedControl;
      }
      return null;
    };
    const openChat = () => {
      const host = document.querySelector('shopify-chat');
      if (typeof host?.show === 'function') {
        host.show();
        return true;
      }
      const control = findNativeChatActivator(host?.shadowRoot);
      if (!control) return false;
      control.click();
      return true;
    };
    button.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      if (openChat()) return;
      button.setAttribute('aria-busy', 'true');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const opened = openChat();
        if (opened || attempts >= 8) {
          window.clearInterval(timer);
          button.removeAttribute('aria-busy');
          if (!opened && hint) hint.hidden = false;
        }
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hub-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-contact]');
    if (!root) return;
    const button = root.querySelector('[data-ber-open-chat]');
    const hint = root.querySelector('[data-ber-chat-hint]');
    if (!button) return;
    const findNativeChatActivator = (rootNode) => {
      if (!rootNode) return null;
      const directControl = rootNode.querySelector?.('button[part="activator"], button.activator');
      if (directControl) return directControl;
      const descendants = rootNode.querySelectorAll?.('*') || [];
      for (const element of descendants) {
        if (!element.shadowRoot) continue;
        const nestedControl = findNativeChatActivator(element.shadowRoot);
        if (nestedControl) return nestedControl;
      }
      return null;
    };
    const openChat = () => {
      const host = document.querySelector('shopify-chat');
      if (typeof host?.show === 'function') {
        host.show();
        return true;
      }
      const control = findNativeChatActivator(host?.shadowRoot);
      if (!control) return false;
      control.click();
      return true;
    };
    button.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      if (openChat()) return;
      button.setAttribute('aria-busy', 'true');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const opened = openChat();
        if (opened || attempts >= 8) {
          window.clearInterval(timer);
          button.removeAttribute('aria-busy');
          if (!opened && hint) hint.hidden = false;
        }
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hub-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-contact]');
    if (!root) return;
    const button = root.querySelector('[data-ber-open-chat]');
    const hint = root.querySelector('[data-ber-chat-hint]');
    if (!button) return;
    const findNativeChatActivator = (rootNode) => {
      if (!rootNode) return null;
      const directControl = rootNode.querySelector?.('button[part="activator"], button.activator');
      if (directControl) return directControl;
      const descendants = rootNode.querySelectorAll?.('*') || [];
      for (const element of descendants) {
        if (!element.shadowRoot) continue;
        const nestedControl = findNativeChatActivator(element.shadowRoot);
        if (nestedControl) return nestedControl;
      }
      return null;
    };
    const openChat = () => {
      const host = document.querySelector('shopify-chat');
      if (typeof host?.show === 'function') {
        host.show();
        return true;
      }
      const control = findNativeChatActivator(host?.shadowRoot);
      if (!control) return false;
      control.click();
      return true;
    };
    button.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      if (openChat()) return;
      button.setAttribute('aria-busy', 'true');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const opened = openChat();
        if (opened || attempts >= 8) {
          window.clearInterval(timer);
          button.removeAttribute('aria-busy');
          if (!opened && hint) hint.hidden = false;
        }
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hub-v6"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-contact]');
    if (!root) return;
    const button = root.querySelector('[data-ber-open-chat]');
    const hint = root.querySelector('[data-ber-chat-hint]');
    if (!button) return;
    const findNativeChatActivator = (rootNode) => {
      if (!rootNode) return null;
      const directControl = rootNode.querySelector?.('button[part="activator"], button.activator');
      if (directControl) return directControl;
      const descendants = rootNode.querySelectorAll?.('*') || [];
      for (const element of descendants) {
        if (!element.shadowRoot) continue;
        const nestedControl = findNativeChatActivator(element.shadowRoot);
        if (nestedControl) return nestedControl;
      }
      return null;
    };
    const openChat = () => {
      const host = document.querySelector('shopify-chat');
      if (typeof host?.show === 'function') {
        host.show();
        return true;
      }
      const control = findNativeChatActivator(host?.shadowRoot);
      if (!control) return false;
      control.click();
      return true;
    };
    button.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      if (openChat()) return;
      button.setAttribute('aria-busy', 'true');
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        const opened = openChat();
        if (opened || attempts >= 8) {
          window.clearInterval(timer);
          button.removeAttribute('aria-busy');
          if (!opened && hint) hint.hidden = false;
        }
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-brand-directory"] && !Shopify.designMode) return;
  try {
    
function initBrandDirectories(scope = document) {
  scope.querySelectorAll('[data-lw-brand-index]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-brand-search]');
    const clear = root.querySelector('[data-brand-clear]');
    const count = root.querySelector('[data-brand-count]');
    const groups = [...root.querySelectorAll('[data-brand-group]')];
    const letters = [...root.querySelectorAll('[data-brand-letter]')];
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const update = () => {
      const query = normalize(input.value);
      let total = 0;
      groups.forEach(group => {
        let matches = 0;
        group.querySelectorAll('[data-brand-name]').forEach(item => {
          const show = normalize(item.dataset.brandName).includes(query);
          item.hidden = !show;
          if (show) matches++;
        });
        group.hidden = matches === 0;
        total += matches;
        const letter = letters.find(item => item.dataset.brandLetter === group.dataset.brandGroup);
        if (letter) {
          if (matches) {letter.removeAttribute('aria-disabled');letter.removeAttribute('tabindex');}
          else {letter.setAttribute('aria-disabled', 'true');letter.tabIndex = -1;}
        }
      });
      clear.hidden = input.value.length === 0;
      count.textContent = total === 1 ? count.dataset.countOne : count.dataset.countTemplate.replace('__COUNT__', total);
      root.querySelector('[data-brand-empty]').hidden = total > 0;
    };
    const reset = () => {input.value = '';update();input.focus();};
    input.addEventListener('input', update);
    input.addEventListener('keydown', event => {if (event.key === 'Escape') reset();});
    clear.addEventListener('click', reset);
    root.querySelector('[data-brand-reset]').addEventListener('click', reset);
    root.querySelector('[data-brand-search-row]').hidden = false;
    const jump = letter => {
      const target = groups.find(group => group.querySelector('h2').textContent.trim() === letter)?.querySelector('h2');
      if (target && !target.closest('[data-brand-group]').hidden) {
        target.scrollIntoView({block:'start',behavior:'instant'});
        target.focus({preventScroll:true});
      }
    };
    letters.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      if (link.getAttribute('aria-disabled') === 'true') return;
      jump(link.textContent.trim());
      history.replaceState(null, '', link.getAttribute('href'));
    }));
    const requested = new URL(location.href).searchParams.get('brand-list');
    if (requested) requestAnimationFrame(() => jump(requested));
  });
}
initBrandDirectories();
document.addEventListener('shopify:section:load', event => initBrandDirectories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lw-brand-strip')) {
  customElements.define('lw-brand-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('.lw-brands-viewport');
      this.track = this.querySelector('.lw-brands-track');
      this.group = this.querySelector('.lw-brands-group');
      this.toggle = this.querySelector('.lw-brands-toggle');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.held = false;
      this.focused = false;
      this.pointers = new Set();
      this.visible = false;
      this.hovered = false;
      this.expanded = false;
      this.dataset.expanded = 'false';
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.querySelector('span').textContent = this.toggle.dataset.expand;
      this.toggle.querySelector('.lw-brands-toggle-icon').textContent = '+';
      this.clone = this.group.cloneNode(true);
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.querySelectorAll('a').forEach(a => a.tabIndex = -1);
      this.clone.querySelectorAll('[id],[data-shopify-editor-block]').forEach(e => { e.removeAttribute('id'); e.removeAttribute('data-shopify-editor-block'); });
      this.clone.hidden = true;
      this.track.append(this.clone);
      this.dataset.ready = '';
      this.querySelector('.lw-brands-controls').hidden = this.group.children.length === 0;
      this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded), options);
      this.viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.pointers.add(event.pointerId);
        clearTimeout(this.resumeTimer);
        this.held = true;
        this.stop();
        this.sync();
      }, options);
      const release = event => {
        if (!this.pointers.delete(event.pointerId) || this.pointers.size) return;
        this.resumeAfterDelay();
      };
      document.addEventListener('pointerup', release, options);
      document.addEventListener('pointercancel', release, options);
      this.viewport.addEventListener('wheel', () => this.resumeAfterDelay(), { ...options, passive: true });
      this.addEventListener('focusin', event => {
        if (!event.target.matches(':focus-visible')) return;
        this.focused = true;
        this.stop();
        if (!this.expanded && this.viewport.contains(event.target)) event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        this.sync();
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          this.sync();
        });
      }, options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); this.sync(); }, options);
      this.addEventListener('shopify:block:select', () => this.setExpanded(true), options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.resize = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        this.start();
      });
      this.resize.observe(this.viewport);
      this.sync();
    }
    position() {
      if (!this.animation || !this.distance) return this.viewport.scrollLeft;
      return ((Number(this.animation.currentTime) || 0) % this.duration) / this.duration * this.distance;
    }
    start() {
      if (this.expanded || this.motion.matches || this.held || this.focused) return;
      const position = this.position();
      this.animation?.cancel();
      this.clone.hidden = false;
      this.viewport.scrollLeft = 0;
      this.distance = this.group.getBoundingClientRect().width;
      if (!this.distance || this.group.children.length < 2) { this.clone.hidden = true; return; }
      const speed = Number(innerWidth <= 767 ? this.dataset.mobileSpeed : this.dataset.desktopSpeed) || 20;
      this.duration = this.distance / speed * 1000;
      this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${this.distance}px)` }], { duration: this.duration, iterations: Infinity, easing: 'linear' });
      this.animation.currentTime = (position % this.distance) / this.distance * this.duration;
      this.sync();
    }
    stop() {
      const position = this.position();
      this.animation?.cancel();
      this.animation = null;
      if (!this.expanded) this.viewport.scrollLeft = position;
    }
    resumeAfterDelay() {
      clearTimeout(this.resumeTimer);
      this.held = true;
      this.stop();
      this.sync();
      this.resumeTimer = setTimeout(() => {
        this.held = false;
        if (this.isConnected) this.sync();
      }, 2000);
    }
    sync() {
      const blocked = this.expanded || this.motion.matches || this.held || this.focused;
      this.dataset.stopped = String(blocked);
      if (!this.animation && !blocked) { this.start(); return; }
      if (this.animation) {
        if (blocked || !this.visible || this.hovered || document.hidden) this.animation.pause();
        else this.animation.play();
      }
    }
    setExpanded(expanded) {
      if (expanded === this.expanded) return;
      const top = this.toggle.getBoundingClientRect().top;
      clearTimeout(this.resumeTimer);
      this.held = false;
      this.pointers.clear();
      this.stop();
      this.expanded = expanded;
      this.dataset.expanded = String(expanded);
      this.clone.hidden = true;
      this.viewport.scrollLeft = 0;
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.querySelector('span').textContent = expanded ? this.toggle.dataset.collapse : this.toggle.dataset.expand;
      this.toggle.querySelector('.lw-brands-toggle-icon').textContent = expanded ? '−' : '+';
      if (!expanded) {
        this.toggle.focus({ preventScroll: true });
        const delta = this.toggle.getBoundingClientRect().top - top;
        if (delta) window.scrollBy({ top: delta, behavior: 'instant' });
      }
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.resumeTimer);
      this.animation?.cancel();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.abort?.abort();
      this.clone?.remove();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-header"]) return;
  try {
    
  if (!customElements.get('lw-nav-rail')) {
    customElements.define('lw-nav-rail', class extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.lw-original-nav');
        this.thumb = this.querySelector('.lw-nav-progress-thumb');
        if (!this.nav || !this.thumb) return;
        this.media = window.matchMedia('(max-width: 1199px)');
        this.frame = 0;
        this.position = offset => {
          const ratio = this.max > 0 ? Math.min(1, Math.max(0, offset / this.max)) : 0;
          const left = this.travel * (this.rtl ? 1 - ratio : ratio);
          this.thumb.style.transform = `translate3d(${left}px,0,0)`;
        };
        this.measure = () => {
          const viewport = this.nav.clientWidth;
          const content = this.nav.scrollWidth;
          const offset = Math.abs(this.nav.scrollLeft);
          const width = Math.min(viewport, Math.max(32, viewport * viewport / Math.max(viewport, content, 1)));
          this.max = Math.max(0, content - viewport);
          this.travel = Math.max(0, viewport - width);
          this.rtl = getComputedStyle(this.nav).direction === 'rtl';
          this.thumb.style.width = `${width}px`;
          this.toggleAttribute('data-overflow', this.max > 1 && this.media.matches);
          this.setAttribute('data-ready', '');
          this.position(offset);
        };
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.position(Math.abs(this.nav.scrollLeft));
          });
        };
        this.nav.addEventListener('scroll', this.onScroll, {passive:true});
        this.media.addEventListener('change', this.measure);
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.nav);
        this.measure();
        document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.nav?.removeEventListener('scroll', this.onScroll);
        this.media?.removeEventListener('change', this.measure);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-village"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(stack) {
    if (instances.has(stack) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    const cards = Array.from(stack.querySelectorAll('.lw-service-panel'));
    const mobile = matchMedia('(max-width: 767px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const states = new Map(cards.map(card => [card, {visible: false, played: false}]));
    const queue = [];
    let observer = null, active = null, disposed = false;
    const enabled = () => !disposed && mobile.matches && !reduced.matches && !document.hidden;
    function removeQueued(card) {
      const index = queue.indexOf(card);
      if (index !== -1) queue.splice(index, 1);
    }
    function cancelActive() {
      if (!active) return;
      const current = active;
      active = null;
      current.animation.cancel();
      current.card.style.willChange = current.willChange;
    }
    function playNext() {
      if (active || !enabled()) return;
      const card = queue.shift();
      if (!card) return;
      const state = states.get(card);
      if (!state.visible || state.played) { playNext(); return; }
      state.played = true;
      const willChange = card.style.willChange;
      card.style.willChange = 'transform';
      const direction = cards.indexOf(card) % 2 === 0 ? 1 : -1;
      const animation = card.animate([
        {transform: 'rotate(0deg)', offset: 0},
        {transform: 'rotate(' + 2.2 * direction + 'deg)', offset: .2},
        {transform: 'rotate(' + -1.5 * direction + 'deg)', offset: .46},
        {transform: 'rotate(' + .7 * direction + 'deg)', offset: .72},
        {transform: 'rotate(0deg)', offset: 1}
      ], {duration: 660, easing: 'ease-in-out', composite: 'add'});
      const current = {card, animation, willChange};
      active = current;
      const finish = () => {
        if (active !== current) return;
        card.style.willChange = willChange;
        active = null;
        playNext();
      };
      animation.finished.then(finish, finish);
    }
    function observe() {
      observer?.disconnect();
      observer = null;
      queue.length = 0;
      cancelActive();
      states.forEach(state => { state.visible = false; state.played = false; });
      if (!enabled()) return;
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.get(entry.target);
          if (!state) return;
          if (!entry.isIntersecting || entry.intersectionRatio === 0) {
            state.visible = false;
            state.played = false;
            removeQueued(entry.target);
            if (active?.card === entry.target) cancelActive();
            return;
          }
          state.visible = entry.intersectionRatio >= .35;
          if (!state.visible) removeQueued(entry.target);
          else if (!state.played && !queue.includes(entry.target)) queue.push(entry.target);
        });
        playNext();
      }, {threshold: [0, .35]});
      cards.forEach(card => observer.observe(card));
    }
    function pauseForInput() {
      queue.length = 0;
      states.forEach(state => { if (state.visible) state.played = true; });
      cancelActive();
    }
    stack.addEventListener('pointerdown', pauseForInput, {passive: true});
    stack.addEventListener('focusin', pauseForInput);
    mobile.addEventListener('change', observe);
    reduced.addEventListener('change', observe);
    document.addEventListener('visibilitychange', observe);
    instances.set(stack, () => {
      disposed = true;
      observer?.disconnect();
      queue.length = 0;
      cancelActive();
      stack.removeEventListener('pointerdown', pauseForInput);
      stack.removeEventListener('focusin', pauseForInput);
      mobile.removeEventListener('change', observe);
      reduced.removeEventListener('change', observe);
      document.removeEventListener('visibilitychange', observe);
      instances.delete(stack);
    });
    observe();
  }
  const scan = root => root.querySelectorAll('.lw-editorial .lw-service-stack').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event =>
    event.target.querySelectorAll('.lw-service-stack').forEach(stack => instances.get(stack)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const key = '__berDescriptionPreviewV5';
  if (window[key]) {
    window[key].refresh();
    return;
  }

  const rowSelector = '.main-product_description-row';
  const atomicSelector = 'h1,h2,h3,h4,h5,h6,img,video,iframe,table,pre,figure,svg';
  const rows = new Set();
  let frame = 0;

  const collectUnits = content => {
    const base = content.getBoundingClientRect();
    const rects = [];

    content.querySelectorAll(atomicSelector).forEach(element => {
      if (element.closest('.main-product_description-collapse-btn')) return;
      const rect = element.getBoundingClientRect();
      if (rect.width && rect.height) {
        rects.push({ top: rect.top - base.top, bottom: rect.bottom - base.top, atomic: true });
      }
    });

    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!node.textContent.trim()) return NodeFilter.FILTER_REJECT;
        if (parent.closest('.main-product_description-collapse-btn')) return NodeFilter.FILTER_REJECT;
        if (parent.closest(atomicSelector)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    let node;
    while ((node = walker.nextNode())) {
      const range = document.createRange();
      range.selectNodeContents(node);
      Array.from(range.getClientRects()).forEach(rect => {
        if (rect.width && rect.height) {
          rects.push({ top: rect.top - base.top, bottom: rect.bottom - base.top, atomic: false });
        }
      });
    }

    rects.sort((a, b) => a.top - b.top);
    const units = [];
    rects.forEach(rect => {
      const unit = units.find(item =>
        Math.abs(item.top - rect.top) <= 2 ||
        (rect.top < item.bottom - 1 && rect.bottom > item.top + 1)
      );
      if (unit) {
        unit.top = Math.min(unit.top, rect.top);
        unit.bottom = Math.max(unit.bottom, rect.bottom);
        unit.atomic = unit.atomic || rect.atomic;
      } else {
        units.push({ ...rect });
      }
    });
    return units.sort((a, b) => a.top - b.top);
  };

  const measure = row => {
    if (!row.isConnected) {
      rows.delete(row);
      return;
    }
    const content = row.querySelector(':scope > .main-product_description-full');
    if (!content) return;

    content.style.removeProperty('--bber-description-preview-height');
    const units = collectUnits(content);
    let height = content.scrollHeight;

    if (units.length > 3) {
      const current = units[2];
      const next = units[3];
      const space = Math.max(0, next.top - current.bottom);
      height = Math.max(current.bottom, Math.floor(current.bottom + space / 2));
    }

    content.style.setProperty('--bber-description-preview-height', Math.ceil(height) + 'px');
    row.dataset.descriptionPreviewReady = 'true';
  };

  const flush = () => {
    frame = 0;
    rows.forEach(measure);
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(flush);
  };

  const bind = row => {
    rows.add(row);
    if (row.dataset.descriptionPreviewBound === 'true') {
      schedule();
      return;
    }

    row.dataset.descriptionPreviewBound = 'true';
    const content = row.querySelector(':scope > .main-product_description-full');
    if (!content) return;

    let width = -1;
    const resizeObserver = new ResizeObserver(entries => {
      const nextWidth = Math.round(entries[0].contentRect.width);
      if (nextWidth !== width) {
        width = nextWidth;
        schedule();
      }
    });
    resizeObserver.observe(content);

    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(content, { childList: true, subtree: true, characterData: true });
    schedule();
  };

  const init = root => {
    if (root.matches && root.matches(rowSelector)) bind(root);
    if (root.querySelectorAll) root.querySelectorAll(rowSelector).forEach(bind);
  };

  const refresh = () => {
    init(document);
    schedule();
  };

  const start = () => {
    refresh();
    const pageObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) init(node);
        });
      });
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', event => init(event.target));
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
  };

  window[key] = { refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-terms-policy-v2"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ber-terms]');
    if (!root) return;
    const disclosure = root.querySelector('[data-ber-terms-disclosure]');
    if (!disclosure) return;
    const desktop = window.matchMedia('(min-width: 900px)');
    const syncDisclosure = event => {
      disclosure.open = event.matches;
    };
    syncDisclosure(desktop);
    desktop.addEventListener('change', syncDisclosure);
  })();

  } catch(e) { console.error(e); }
})();
})();
